<template>

      <div class="row align-items-center">
        <div class="col-12 col-sm-12">
            <div class="profile-pic-wrapper position-relative">
              <app-input v-model="profile_picture"
                         :generate-file-url="false"
                         :label="$t('change_picture')"
                         :wrapper-class="'wrapper mx-xl-auto'"
                         name="organization_logo"
                         type="custom-file-upload"
                         @change="changeProfile()"/>
            </div>

        </div>   
      </div>

</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
  name: "PersonOrgDetailsUserInfoFund",
  props: {
    userInfoData: {
      type: Object,
      required: true
    },
    userInfoSyncUrl: {
      type: String,
      required: true
    },
    componentType: {
      type: String,
      required: true
    }
  },
  mixins: [FormMixin],
  data() {
    return {
      profile_picture: '',
      formatDateToLocal
    }
  },
  methods: {
    changeProfile() {
      let formData = new FormData();
      formData.append('profile_picture', this.profile_picture);
      this.submitFromFixin('post', this.userInfoSyncUrl, formData);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$emit('update-request')
    },
  },
  mounted() {
    this.profile_picture =
      this.userInfoData.profile_picture ? urlGenerator(this.userInfoData.profile_picture.path) : urlGenerator(`/images/${this.componentType}.png`);
  }
}
</script>
